(function () {
  if (window.__PDP_NOJUMP_V2) return;
  window.__PDP_NOJUMP_V2 = true;

  let armed = false;
  let cancelTimer = null;
  let user = false;

  const prev = {
    scrollTo: window.scrollTo.bind(window),
    scrollBy: window.scrollBy.bind(window),
    scrollIntoView: Element.prototype.scrollIntoView,
    focus: HTMLElement.prototype.focus,
  };

  function patch() {
    window.scrollTo = function () {
      if (armed && !user) return;
      return prev.scrollTo(...arguments);
    };

    window.scrollBy = function () {
      if (armed && !user) return;
      return prev.scrollBy(...arguments);
    };

    Element.prototype.scrollIntoView = function () {
      if (armed && !user) return;
      return prev.scrollIntoView.apply(this, arguments);
    };

    HTMLElement.prototype.focus = function () {
      if (armed && !user) {
        try {
          return prev.focus.call(this, { preventScroll: true });
        } catch (error) {
          return prev.focus.call(this);
        }
      }

      return prev.focus.apply(this, arguments);
    };
  }

  function unpatch() {
    window.scrollTo = prev.scrollTo;
    window.scrollBy = prev.scrollBy;
    Element.prototype.scrollIntoView = prev.scrollIntoView;
    HTMLElement.prototype.focus = prev.focus;
  }

  function freeze(ms = 800) {
    armed = true;
    user = false;
    patch();

    const html = document.documentElement;
    const body = document.body;
    const originalHtmlBehavior = html.style.scrollBehavior;
    const originalBodyBehavior = body.style.scrollBehavior;

    html.style.scrollBehavior = 'auto';
    body.style.scrollBehavior = 'auto';

    clearTimeout(cancelTimer);
    cancelTimer = setTimeout(() => {
      armed = false;
      unpatch();
      html.style.scrollBehavior = originalHtmlBehavior;
      body.style.scrollBehavior = originalBodyBehavior;
    }, ms);
  }

  ['wheel', 'touchmove', 'keydown'].forEach((eventName) => {
    window.addEventListener(
      eventName,
      () => {
        user = true;
      },
      { passive: true }
    );
  });

  const armVariantChange = () => freeze(800);
  document.addEventListener('variant:change', armVariantChange);
  document.addEventListener('variant:changed', armVariantChange);
  document.addEventListener('product:variant-change', armVariantChange);

  document.addEventListener(
    'mousedown',
    (event) => {
      const hit = event.target.closest(
        '.product-form__input input[type="radio"],' +
          '.product-form__input label,' +
          '.product-form__input button[role="radio"],' +
          '.variant-pill,' +
          '.product-form__input .swatch,' +
          '.product-form__input .variant-pills'
      );

      if (hit) freeze(800);
    },
    { capture: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      if (!armed || user) return;

      const trigger = event.target.closest(
        'a[href^="#"], button[aria-controls^="Media-"], .thumbnail, .thumbnail-list__item button'
      );

      if (!trigger) return;

      const href = trigger.getAttribute('href') || '';
      if (!href.startsWith('#')) return;

      event.preventDefault();
      event.stopPropagation();
      history.replaceState('', document.title, location.pathname + location.search);
    },
    { capture: true }
  );

  window.addEventListener(
    'load',
    () => {
      freeze(500);
    },
    { once: true }
  );
})();
